import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const ProfileRoutes: RouteObject = {
	path: "profile/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { Profile } =
					await import("@/app/application/admin-menu/Profile");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<Profile />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
